import { Plus, Settings } from "lucide-react";
import MenuIconTooltip from "./MenuIconTooltip";
import { MENU_GROUPINGS_TOOLTIPS } from "../constants/menuTooltips";

const ICON_COLOR = "#39210d";

export default function MenuGroupingsMiddle({
  visible = false,
  settingsActive = false,
  onCreate = () => {},
  onSettingsClick = () => {},
}) {
  if (!visible) return <div className="menuMilieuContainer" />;

  return (
    <div className="menuMilieuContainer menuGroupingsMiddle">
      <MenuIconTooltip
        tooltip={MENU_GROUPINGS_TOOLTIPS.create}
        placement="left"
        portal
        className="icon active"
      >
        <Plus
          size={50}
          color={ICON_COLOR}
          strokeWidth={1}
          onClick={onCreate}
          aria-label="Créer un groupement thématique"
          style={{ cursor: "pointer" }}
        />
      </MenuIconTooltip>

      <MenuIconTooltip
        tooltip={MENU_GROUPINGS_TOOLTIPS.settings}
        placement="left"
        portal
      >
        <Settings
          size={50}
          color={settingsActive ? ICON_COLOR : "#b8a99a"}
          strokeWidth={1}
          onClick={onSettingsClick}
          aria-label="Préférences d'affichage"
          style={{
            opacity: settingsActive ? 1 : 0.3,
            cursor: "pointer",
          }}
        />
      </MenuIconTooltip>
    </div>
  );
}
